export default "__VITE_ASSET__ccf33699__"